<template>
	<edit></edit>
</template>

<script>
	import edit from './coupon_task_edit.vue'
	
	export default {
		name: 'coupon_task_add',
		
		components: {
			edit
		}
	}
</script>